export const conditionObjects = [
  { option: 'ACL tear (anterior cruciate ligament tear)', sideOfBody: true },
  { option: 'acne' },
  { option: 'adjustment disorder' },
  { option: 'AL amyloidosis (primary amyloidosis)' },
  { option: 'alopecia' },
  { option: 'ALS (amyotrophic lateral sclerosis)' },
  { option: "Alzheimer's disease" },
  { option: 'anal cancer' },
  { option: 'anal or perianal fistula (fistula-in-ano)' },
  { option: 'ankle replacement (ankle arthroplasty)', sideOfBody: true },
  { option: 'ankle sprain', sideOfBody: true },
  { option: 'ankylosis in ankle', sideOfBody: true },
  { option: 'ankylosis in elbow', sideOfBody: true },
  { option: 'ankylosis in hand or fingers', sideOfBody: true },
  { option: 'ankylosis in hip', sideOfBody: true },
  { option: 'ankylosis in knee', sideOfBody: true },
  { option: 'ankylosis in shoulder', sideOfBody: true },
  { option: 'ankylosis in wrist', sideOfBody: true },
  { option: 'anorexia (type of eating disorder)' },
  { option: 'aortic insufficiency (aortic regurgitation)' },
  { option: 'aortic valve disease' },
  { option: 'arrhythmia (irregular heartbeat)' },
  { option: 'asbestosis, silicosis, or other pneumoconiosis' },
  { option: 'asthma' },
  {
    option: 'astragalectomy or talectomy (removal of talus bone in ankle)',
    sideOfBody: true,
  },
  { option: "athlete's foot (tinea pedis)" },
  { option: 'atrial fibrillation (A-fib)' },
  { option: 'back pain or stiffness, diagnosis unknown' },
  { option: 'bipolar disorder' },
  { option: 'biventricular hypertrophy' },
  { option: 'bladder cancer' },
  { option: 'bladder stones' },
  { option: 'bone cancer, including osteosarcoma, extremities or trunk' },
  { option: 'bone cancer, including osteosarcoma, head or neck' },
  { option: 'Boutonniere deformity in fingers', sideOfBody: true },
  { option: 'brain cancer, including glioblastoma' },
  { option: 'breast cancer', sideOfBody: true },
  { option: 'bronchiectasis' },
  { option: 'bruxism (teeth grinding)' },
  { option: 'bulimia (type of eating disorder)' },
  { option: 'bunions (hallux valgus)', sideOfBody: true },
  { option: 'bursitis in ankle', sideOfBody: true },
  { option: 'bursitis in elbow', sideOfBody: true },
  { option: 'bursitis in foot', sideOfBody: true },
  { option: 'bursitis in hand or fingers', sideOfBody: true },
  { option: 'bursitis in hip', sideOfBody: true },
  { option: 'bursitis in knee', sideOfBody: true },
  { option: 'bursitis in shoulder', sideOfBody: true },
  { option: 'bursitis in wrist', sideOfBody: true },
  { option: 'carpal tunnel syndrome', sideOfBody: true },
  { option: 'cervical cancer' },
  { option: 'cervical spinal stenosis (narrowing of spinal canal in neck)' },
  { option: 'chloracne' },
  { option: 'chronic bronchitis' },
  { option: 'chronic conjunctivitis (pink eye)' },
  { option: 'chronic fatigue syndrome' },
  { option: 'chronic kidney disease (CKD)' },
  { option: 'chronic laryngitis' },
  { option: 'chronic myelogenous leukemia (CML)' },
  { option: 'chronic nephritis (inflammation of kidneys)' },
  { option: 'chronic obstructive pulmonary disease (COPD)' },
  { option: "chronic otitis externa (swimmer's ear)", sideOfBody: true },
  {
    option: 'chronic otitis media (chronic middle ear infection)',
    sideOfBody: true,
  },
  { option: 'chronic sinusitis' },
  {
    option: 'chronic suppurative otitis media (CSOM) or mastoiditis',
    sideOfBody: true,
  },
  { option: 'chronic urticaria (chronic hives)' },
  { option: 'cirrhosis (scarring of liver)' },
  { option: 'claw foot (pes cavus)', sideOfBody: true },
  { option: 'colorectal cancer or colon cancer' },
  { option: 'complete loss of sense of smell (anosmia)' },
  { option: 'complete loss of sense of taste (ageusia)' },
  { option: 'congestive heart failure (CHF)' },
  { option: 'constrictive bronchiolitis (obliterative bronchiolitis)' },
  { option: 'conversion disorder (FNSD)' },
  { option: 'coronary artery disease (CAD or arteriosclerotic heart disease)' },
  { option: 'costochondritis' },
  {
    option:
      'Cranial nerve paralysis or cranial neuritis (inflammation of cranial nerves)',
  },
  { option: 'cranial neuralgia (cranial nerve pain)' },
  { option: "Crohn's disease" },
  { option: 'cyclothymic disorder (mild bipolar disorder)' },
  {
    option: "De Quervain's tenosynovitis (De Quervain's syndrome)",
    sideOfBody: true,
  },
  { option: 'decompression illness' },
  { option: 'deep vein thrombosis (DVT) in leg', sideOfBody: true },
  {
    option: 'degenerative arthritis (osteoarthritis) in ankle',
    sideOfBody: true,
  },
  {
    option: 'degenerative arthritis (osteoarthritis) in elbow',
    sideOfBody: true,
  },
  {
    option: 'degenerative arthritis (osteoarthritis) in foot',
    sideOfBody: true,
  },
  {
    option: 'degenerative arthritis (osteoarthritis) in hand or fingers',
    sideOfBody: true,
  },
  {
    option: 'degenerative arthritis (osteoarthritis) in hip',
    sideOfBody: true,
  },
  {
    option: 'degenerative arthritis (osteoarthritis) in knee',
    sideOfBody: true,
  },
  {
    option: 'degenerative arthritis (osteoarthritis) in shoulder',
    sideOfBody: true,
  },
  {
    option: 'degenerative arthritis (osteoarthritis) in wrist',
    sideOfBody: true,
  },
  { option: 'delirium' },
  { option: 'delusional disorder' },
  { option: 'depersonalization-derealization disorder (DPDR)' },
  { option: 'depression (major depressive disorder)' },
  { option: 'deviated septum' },
  { option: 'diabetes insipidus' },
  { option: 'diabetes, type 1 or type 2' },
  { option: 'diabetic nephropathy (diabetic kidney disease)' },
  {
    option: 'diabetic peripheral neuropathy lower extremities',
    sideOfBody: true,
  },
  {
    option: 'diabetic peripheral neuropathy upper extremities',
    sideOfBody: true,
  },
  { option: 'diabetic retinopathy' },
  { option: 'dissociative amnesia' },
  { option: 'dissociative identity disorder' },
  { option: 'diverticulitis or diverticulosis' },
  { option: 'dry eye syndrome' },
  {
    option:
      "Dupuytren's contracture (abnormal thickening of tissues in palm of hand)",
    sideOfBody: true,
  },
  {
    option:
      'dysphagia (difficulty swallowing), associated with neurological disorder',
  },
  {
    option:
      'dysphagia (difficulty swallowing), not associated with neurological disorder',
  },
  { option: 'ear cancer' },
  { option: 'eczema (atopic dermatitis)' },
  { option: 'elbow replacement (elbow arthroplasty)', sideOfBody: true },
  { option: 'emphysema' },
  { option: 'endometriosis' },
  { option: 'eosinophilic granuloma of lung' },
  { option: 'enlarged prostate (benign prostatic hyperplasia or BPH)' },
  { option: 'epididymitis' },
  { option: 'epiphora (watery eyes)' },
  { option: 'erectile dysfunction (ED)' },
  { option: 'esophageal cancer' },
  { option: 'esophageal stricture (narrowing of esophagus)' },
  { option: 'eye cancer, including melanoma of the eye' },
  { option: 'fecal incontinence (loss of bowel control)' },
  { option: 'female sexual arousal disorder (FSAD)' },
  { option: 'femoral hernia (hernia in thigh area)' },
  { option: 'fibromyalgia' },
  { option: 'flatfoot (pes planus)', sideOfBody: true },
  { option: 'foot fracture (tarsal or metatarsal fracture)', sideOfBody: true },
  { option: 'foot pain or strain, diagnosis unknown', sideOfBody: true },
  { option: 'frostbite in foot', sideOfBody: true },
  { option: 'frostbite in hand or fingers', sideOfBody: true },
  { option: 'frozen shoulder (adhesive capsulitis)', sideOfBody: true },
  { option: 'gallstones (cholelithiasis)' },
  { option: "gamekeeper's thumb", sideOfBody: true },
  { option: 'ganglion cyst in hand or fingers', sideOfBody: true },
  { option: 'ganglion cyst in wrist', sideOfBody: true },
  { option: 'gastritis' },
  { option: 'generalized anxiety disorder (GAD)' },
  { option: 'GERD (gastroesophageal reflux disease)' },
  { option: 'glaucoma' },
  { option: "golfer's elbow (medial epicondylitis)", sideOfBody: true },
  { option: 'gonococcal arthritis' },
  { option: 'gout in foot', sideOfBody: true },
  { option: 'gout in wrist', sideOfBody: true },
  { option: 'granulomatous disease' },
  { option: 'granulomatous rhinitis' },
  {
    option: 'greater trochanteric pain syndrome (lateral hip pain)',
    sideOfBody: true,
  },
  { option: 'hallux rigidus (big toe arthritis)', sideOfBody: true },
  { option: 'hammer toe', sideOfBody: true },
  { option: "Hansen's disease (leprosy)" },
  { option: 'hearing loss' },
  { option: 'heart attack (myocardial infarction)' },
  { option: 'heart bypass surgery (coronary artery bypass graft)' },
  { option: 'hemorrhoids' },
  { option: 'hepatitis B' },
  { option: 'hepatitis C' },
  { option: 'herpes (herpes simplex virus or HSV)' },
  { option: 'hiatal hernia' },
  {
    option: 'hip impingement (femoroacetabular impingement or FAI)',
    sideOfBody: true,
  },
  { option: 'hip pain or limited motion, diagnosis unknown', sideOfBody: true },
  { option: 'hip replacement (hip arthroplasty)', sideOfBody: true },
  { option: 'hip sprain', sideOfBody: true },
  { option: 'HIV-related illness' },
  { option: 'Hodgkin lymphoma' },
  { option: 'hydrocele' },
  { option: 'hyperhidrosis (excessive sweating)' },
  { option: 'hypertension (high blood pressure)' },
  { option: 'hyperthyroidism (overactive thyroid)' },
  { option: 'hypopharyngeal cancer' },
  { option: 'hypothyroidism (underactive thyroid)' },
  { option: 'hysterectomy (removal of uterus)' },
  {
    option: 'hysterectomy and ovariectomy (removal of uterus and both ovaries)',
  },
  { option: 'illness anxiety disorder (hypochondria)' },
  { option: 'immersion foot', sideOfBody: true },
  { option: 'inguinal hernia (hernia in groin)' },
  { option: 'insomnia (difficulty sleeping)' },
  { option: 'interstitial lung disease (ILD), pneumonitis, or fibrosis' },
  { option: 'intervertebral disc syndrome (IVDS), back' },
  { option: 'intervertebral disc syndrome (IVDS), neck' },
  { option: 'iron deficiency anemia' },
  { option: 'irritable bowel syndrome (IBS)' },
  { option: 'jaw cancer' },
  { option: 'keratinization skin disorders' },
  { option: 'kidney cancer (renal cancer)', sideOfBody: true },
  { option: 'kidney removal (nephrectomy)' },
  { option: 'kidney stones (nephrolithiasis)' },
  { option: 'kidney transplant' },
  { option: 'knee hyperextension (genu recurvatum)', sideOfBody: true },
  { option: 'knee instability', sideOfBody: true },
  { option: 'knee or patellar dislocation', sideOfBody: true },
  { option: 'knee or patellar fracture', sideOfBody: true },
  { option: 'knee pain or stiffness, diagnosis unknown', sideOfBody: true },
  { option: 'knee replacement (knee arthroplasty)', sideOfBody: true },
  { option: 'knee strain or sprain', sideOfBody: true },
  { option: 'labyrinthitis (inner ear inflammation)', sideOfBody: true },
  { option: 'laryngeal cancer (cancer of larynx)' },
  { option: 'left ventricular hypertrophy (LVH)' },
  { option: 'leukemia' },
  { option: 'liver cancer, including hepatocellular carcinoma (HCC)' },
  { option: 'loss of both eyes' },
  { option: 'loss of teeth due to bone loss' },
  { option: 'lower back pain or stiffness, diagnosis unknown' },
  { option: 'lower back sprain (lumbosacral sprain)' },
  { option: 'lower back strain (lumbosacral strain)' },
  {
    option: 'lumbar spinal stenosis (narrowing of spinal canal in lower back)',
  },
  { option: 'lung cancer' },
  { option: 'lupus' },
  { option: 'lymphatic filariasis' },
  { option: 'malaria' },
  { option: 'malignant tumor in spinal cord' },
  { option: 'mallet finger', sideOfBody: true },
  { option: 'melanoma of the skin' },
  { option: "Meniere's disease" },
  { option: 'meniscectomy (removal of meniscus)', sideOfBody: true },
  { option: 'meniscus tear', sideOfBody: true },
  { option: 'metatarsalgia (pain in ball of foot)', sideOfBody: true },
  { option: 'middle back sprain (thoracic sprain)' },
  { option: 'middle back strain (thoracic strain)' },
  { option: 'migraines (headaches)' },
  { option: 'mitral regurgitation' },
  { option: 'mitral valve prolapse (Barlow syndrome)' },
  { option: "Morton's neuroma", sideOfBody: true },
  { option: 'multiple myeloma, extremities or trunk' },
  { option: 'multiple myeloma, head or neck' },
  { option: 'multiple sclerosis (MS)' },
  { option: 'muscle hernia' },
  { option: 'myasthenia gravis' },
  { option: 'nasopharyngeal cancer' },
  { option: 'neck pain or stiffness, diagnosis unknown' },
  { option: 'neck sprain (cervical sprain)' },
  { option: 'neck strain (cervical strain)' },
  { option: 'nerve-related soft-tissue sarcoma, extremities or trunk' },
  { option: 'nerve-related soft-tissue sarcoma, head or neck' },
  { option: 'neurogenic bladder' },
  {
    option: 'non-diabetic peripheral neuropathy lower extremities',
    sideOfBody: true,
  },
  {
    option: 'non-diabetic peripheral neuropathy upper extremities',
    sideOfBody: true,
  },
  { option: 'non-Hodgkin lymphoma' },
  { option: 'obsessive compulsive disorder (OCD)' },
  { option: 'onychomycosis (toenail fungus)' },
  { option: 'oral cavity squamous cell carcinoma' },
  { option: 'orchitis (inflammation of testicles)' },
  { option: 'oropharyngeal cancer' },
  { option: 'osteomyelitis' },
  { option: 'ovarian adhesions' },
  { option: 'ovarian cancer', sideOfBody: true },
  { option: 'ovarian cysts' },
  { option: 'ovariectomy (removal of one or both ovaries)' },
  { option: 'pancreatic cancer' },
  { option: 'panic disorder' },
  { option: 'paranasal sinus or nasal cavity cancer' },
  { option: "Parkinson's disease" },
  { option: 'patellar or quadriceps tendon rupture', sideOfBody: true },
  { option: 'patellofemoral pain syndrome', sideOfBody: true },
  { option: 'PCL tear (posterior cruciate ligament tear)', sideOfBody: true },
  { option: 'penile cancer' },
  {
    option: 'perforated eardrum (perforated tympanic membrane)',
    sideOfBody: true,
  },
  { option: 'persistent depressive disorder (dysthymic disorder)' },
  { option: 'pharyngeal cancer (throat cancer)' },
  { option: 'phobia (agoraphobia, claustrophobia, or other phobia)' },
  { option: 'plantar fasciitis', sideOfBody: true },
  { option: 'plantar warts (foot warts)', sideOfBody: true },
  { option: 'pleurisy (pleuritis)' },
  { option: 'pneumococcal arthritis' },
  { option: 'polycystic ovary syndrome (PCOS)' },
  { option: 'post-traumatic arthritis in ankle', sideOfBody: true },
  { option: 'post-traumatic arthritis in elbow', sideOfBody: true },
  { option: 'post-traumatic arthritis in foot', sideOfBody: true },
  { option: 'post-traumatic arthritis in hand or fingers', sideOfBody: true },
  { option: 'post-traumatic arthritis in hip', sideOfBody: true },
  { option: 'post-traumatic arthritis in knee', sideOfBody: true },
  { option: 'post-traumatic arthritis in shoulder', sideOfBody: true },
  { option: 'post-traumatic arthritis in wrist', sideOfBody: true },
  { option: 'poststreptococcal arthritis' },
  { option: 'premature ventricular contractions' },
  { option: 'proctitis (inflammation of rectum)' },
  { option: 'prostate cancer' },
  { option: 'prostatitis (inflammation of prostate)' },
  {
    option:
      'pseudofolliculitis barbae (razor bumps, shave bumps, or ingrown hairs)',
  },
  { option: 'psoriasis' },
  { option: 'PTSD (post-traumatic stress disorder)' },
  { option: 'pulmonary alveolar proteinosis (PAP)' },
  { option: 'pulmonary fibrosis' },
  { option: 'pulmonary granuloma (lung nodule)' },
  { option: 'radiculopathy lower extremities', sideOfBody: true },
  { option: 'radiculopathy upper extremities', sideOfBody: true },
  { option: "Raynaud's disease" },
  { option: 'restless leg syndrome (RLS)' },
  { option: 'rheumatoid arthritis' },
  { option: 'rhinitis, chronic' },
  { option: 'rib fracture', sideOfBody: true },
  { option: 'rib removal' },
  { option: 'right ventricular hypertrophy (RVH)' },
  { option: 'ringworm (dermatophytosis)' },
  { option: 'rotator cuff tear', sideOfBody: true },
  { option: 'salivary gland cancer' },
  { option: 'sarcoidosis' },
  { option: 'scars, extremities or trunk' },
  { option: 'scars, head, face or neck' },
  { option: 'schizoaffective disorder' },
  { option: 'schizophrenia' },
  { option: 'sciatica (sciatic nerve radiculopathy)', sideOfBody: true },
  { option: 'scoliosis' },
  { option: 'shin splints', sideOfBody: true },
  { option: 'shoulder dislocation', sideOfBody: true },
  { option: 'shoulder impingement syndrome', sideOfBody: true },
  { option: 'shoulder pain or stiffness, diagnosis unknown', sideOfBody: true },
  { option: 'shoulder replacement (shoulder arthroplasty)', sideOfBody: true },
  { option: 'shoulder strain', sideOfBody: true },
  { option: 'sickle cell anemia' },
  { option: 'skin cancer (other than melanoma), extremities or trunk' },
  { option: 'skin cancer (other than melanoma), head or neck' },
  {
    option: 'SLAP tear (superior labral anterior to posterior tear)',
    sideOfBody: true,
  },
  { option: 'sleep apnea' },
  { option: 'small intestine cancer' },
  {
    option:
      'soft-tissue sarcoma of muscle, fat, or fibrous connective tissue, extremities or trunk',
  },
  {
    option:
      'soft-tissue sarcoma of muscle, fat, or fibrous connective tissue, head or neck',
  },
  { option: 'social anxiety disorder (social phobia)' },
  { option: 'somatic symptom disorder (SSD)' },
  { option: 'spinal arthritis, back' },
  { option: 'spinal arthritis, neck' },
  { option: 'spondylolisthesis, back' },
  { option: 'spondylolisthesis, neck' },
  { option: 'stomach cancer' },
  { option: 'stress fracture in leg', sideOfBody: true },
  { option: 'syphilitic arthritis' },
  { option: 'tachycardia' },
  { option: 'tailbone (coccyx) removal' },
  { option: 'temporomandibular disorder, including TMJ' },
  { option: 'tendinosis in hand or fingers', sideOfBody: true },
  { option: 'tendonitis (tendinitis) in ankle', sideOfBody: true },
  { option: 'tendonitis (tendinitis) in elbow', sideOfBody: true },
  { option: 'tendonitis (tendinitis) in foot', sideOfBody: true },
  { option: 'tendonitis (tendinitis) in hand or fingers', sideOfBody: true },
  { option: 'tendonitis (tendinitis) in hip', sideOfBody: true },
  { option: 'tendonitis (tendinitis) in knee', sideOfBody: true },
  { option: 'tendonitis (tendinitis) in shoulder', sideOfBody: true },
  { option: 'tendonitis (tendinitis) in wrist', sideOfBody: true },
  { option: 'tennis elbow (lateral epicondylitis)', sideOfBody: true },
  { option: 'tenosynovitis in hand or fingers', sideOfBody: true },
  { option: 'tenosynovitis in wrist', sideOfBody: true },
  { option: 'testicular cancer', sideOfBody: true },
  { option: 'thyroid cancer' },
  { option: 'tibia or fibula fracture', sideOfBody: true },
  { option: 'Tietze syndrome' },
  { option: 'tinnitus (ringing or hissing in ears)' },
  { option: 'tongue cancer' },
  { option: 'trachea cancer (cancer of windpipe)' },
  { option: 'traumatic brain injury (TBI)' },
  { option: 'trigger finger', sideOfBody: true },
  { option: 'typhoid arthritis' },
  { option: 'ulcerative colitis' },
  { option: 'ureteral cancer (ureter cancer)' },
  { option: 'urethritis' },
  { option: 'urinary incontinence (loss of bladder control)' },
  { option: 'uterine cancer' },
  { option: 'vaginal cancer' },
  { option: 'varicocele', sideOfBody: true },
  { option: 'varicose veins in leg', sideOfBody: true },
  {
    option:
      'vascular soft-tissue sarcoma, including angiosarcoma, extremities or trunk',
  },
  {
    option:
      'vascular soft-tissue sarcoma, including angiosarcoma, head or neck',
  },
  { option: 'ventral hernia (hernia in abdomen)' },
  { option: 'vertigo or dizziness' },
  {
    option:
      'visual impairment, including blurry vision, blindness and double vision',
  },
  { option: 'vitiligo' },
  { option: 'vulvar cancer' },
  { option: 'weak foot', sideOfBody: true },
  { option: 'Wolff-Parkinson-White syndrome' },
  { option: 'wrist fracture', sideOfBody: true },
  { option: 'wrist replacement (wrist arthroplasty)', sideOfBody: true },
  { option: 'wrist sprain', sideOfBody: true },
];

export const conditionOptions = conditionObjects.map(
  condition => condition.option,
);
